import * as actionTypes from '../action-types';
import { toaster } from '../../services/toast-service';
import { takeLeading, put } from 'redux-saga/effects';
import { getAPI, postAPI } from '../../utils/api-function';
import { get_milan_sathi_profile, send_connection_request } from '../../utils/api-routes';

function* getMilanSathiProfile(action) {
    try {
        const { payload } = action;
        const { data } = yield getAPI({ key: 'Web', url: get_milan_sathi_profile({ ...payload, userId: localStorage.getItem('userId') }), project: 'Milan-Sathi' });
        console.log("Get Milan Sathi Profile Saga Response :::", data);

        if (data?.success) {
            yield put({ type: actionTypes.SET_MILAN_SATHI_PROFILE, payload: data?.data });
        } else {
            yield put({ type: actionTypes.SET_MILAN_SATHI_PROFILE, payload: [] });
        }
    } catch (error) {
        console.log("Get Milan Sathi Profile Saga Error :::", error);
        yield put({ type: actionTypes.SET_MILAN_SATHI_PROFILE, payload: [] });
    }
};

function* sendConnectionRequest(action) {
    try {
        const { payload } = action;
        const { data } = yield postAPI({ key: 'Web', url: send_connection_request, project: 'Milan-Sathi', payload });
        console.log("Send Connection Request Saga Response :::", data);

        if (data?.success) {
            toaster.success({ text: data?.message });
        }

    } catch (error) {
        toaster.error({ text: error?.response?.data?.error || 'Connection failed' });
        console.log("Send Connection Request Saga Error :::", error);
    }
};

export default function* milansathiSaga() {
    yield takeLeading(actionTypes.GET_MILAN_SATHI_PROFILE, getMilanSathiProfile);
    yield takeLeading(actionTypes.SEND_CONNECTION_REQUEST, sendConnectionRequest);
};